"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Google = function Google(props) {
	return _react2.default.createElement(
		"svg",
		_extends({}, props, { viewBox: "0 0 48 48" }),
		_react2.default.createElement("path", { d: "M14 22v4.8h7.94c-.32 2.06-2.4 6.04-7.94 6.04a8.84 8.84 0 0 1 0-17.68 7.88 7.88 0 0 1 5.58 2.16l3.8-3.66A13.418 13.418 0 0 0 14 10a14 14 0 0 0 0 28c8.08 0 13.44-5.68 13.44-13.68a12.776 12.776 0 0 0-.22-2.32H14zm0 0l34 4h-6v6h-4v-6h-6v-4h6v-6h4v6h6v4z" })
	);
};

exports.default = Google;


//////////////////
// WEBPACK FOOTER
// ./~/react-share-icons/lib/Google/index.js
// module id = 172
// module chunks = 0